export class ClientInfosSummary {

    public name?: string;
    public contact?: string;
    public city?: string;
    public phone?: string;
    public email?: string;
    public accountElisId?: string;


    constructor(name: string, contact: string, city: string, phone: string, email: string, accountElisId?: string) {
        this.name = name;
        this.contact = contact;
        this.city = city;
        this.phone = phone;
        this.email = email;
        this.accountElisId = accountElisId;
    }
}
